/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        jQuery(".external-link-fa a").prepend('<i class="fa fa-external-link" style="color: #3f3f3f !important; "></i>');
        // remove last div border in Daily Menus
        jQuery('.container .divider-border:last').hide(0, function() {
          jQuery(this).remove();
        });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    // Initialize isotope on gallery page
    'gallery': {
      init: function() {

      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

  // Initialize Slick Slider
  $('.hero-slider').slick({
    autoplay: true,
    arrows: false,
    nextArrow: '<i class="fa fa-caret-right fa-4x" aria-hidden="true"></i>',
    prevArrow: '<i class="fa fa-caret-left fa-4x" aria-hidden="true"></i>',
    mobileFirst: false,
    dots: true,
    fade: true,
    autoplaySpeed: 6000
  });
    //Bruinwoods new small slider
  $('.bw-family-holidays-slider').slick({
    dots: false,
    infinite: true,
    speed: 500,
    fade: true,
    mobileFirst: false,
    draggable: false,
    autoplay: true,
    arrows: false,
    touchMove: false,
    dots: false
  });

  // Initialize Bootstrap Hover Dropdown
  $('.dropdown-toggle').dropdownHover();

  $('ul.nav li.dropdown').hover(function() {
    $(this).find('.dropdown-menu').stop(true, true).delay(100).fadeIn(500);
  }, function() {
    $(this).find('.dropdown-menu').stop(true, true).delay(100).fadeOut(500);
  });

  //Initialize Accordion for Policies and FAQ
  $(document).ready(function() {
    $('.collapse.in').prev('.panel-heading').addClass('active');
    $('#accordion, #bs-collapse')
      .on('show.bs.collapse', function(a) {
        $(a.target).prev('.panel-heading').addClass('active');
      })
      .on('hide.bs.collapse', function(a) {
        $(a.target).prev('.panel-heading').removeClass('active');
      });
  });



  //Smoothscroll was here

  //Initialize isotope
  $('.gallery').imagesLoaded(function() {
    $('.gallery').isotope({
      // options
      itemSelector: '.gallery__item',
      layoutMode: 'masonry' //fitRows
    });
  });
  // filter items on button click
  $('.category-filters').on('click', 'button', function() {
    var filterValue = $(this).attr('data-filter');
    $('.gallery').isotope({
      filter: filterValue
    });
  });
  $('.enlarge').hover(
    function() {
      $(this).show();
    },
    function() {
      $(this).hide();
    }
  );

  // Subscribe to Mailing List Modal - may be able to do this w/o resorting to more jquery
  /*  $(document).on("gform_confirmation_loaded", function (e, form_id) {
    // code to run upon successful form submission
      }); */

  // remove last div border in Daily Menus
  jQuery('.container .divider-border:last').hide(0, function() {
    jQuery(this).remove();
  });

  jQuery(document).ready(function() {
    jQuery('.dropdown').hover(
      function() { jQuery(this).addClass('open') }
    )
  });



  // function checkPosition()
  // {
  //     if(jQuery(window).width() < 767)
  //     {
  //         jQuery('.dropdown').addClass('open')
  //     } else {
  //         jQuery('.dropdown').removeClass('open')
  //     }
  // }

  // checkPosition();

})(jQuery); // Fully reference jQuery after this point.
